import * as React from 'react'
import { NavLink } from 'react-router-dom'
import styled from '../../utils/styled'
import LayoutContainer from '../../containers/LayoutContainer'
import Container from './Container'
import { css } from 'emotion'

import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { ThemeColors } from '../../store/layout'
import * as layoutActions from '../../store/layout/actions'
import { Dispatch } from 'redux'
import { AuthUserContext } from '../firebase/AuthUserContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fab)

interface PropsFromState {
  isMenuOn: boolean
}

// Props passed from mapDispatchToProps
interface PropsFromDispatch {
  toggleMenu: typeof layoutActions.toggleMenu
}

type LayoutContainerProps = PropsFromState & PropsFromDispatch

interface HeaderProps {
  title: string
  logo: string
}
const FancyHeader: React.SFC<LayoutContainerProps & HeaderProps> = ({
  title,
  logo,
  isMenuOn,
  toggleMenu
}) => (
  <nav
    className={'fancynavbar' + (!isMenuOn ? ' collapsed' : ' show')}
    role="navigation"
    id="navbarCollapse"
  >
    <div className="fancynavbar-togglerbar">
      <a className="fancynavbar-brand" href="/">
        <img className="fancynavbar-brand-img" src={logo} alt="" width="50" height="50" />
        {/* <!--You can use icon or text logo as well--> */}
        {/* <!--<span className='fab fa-superpowers fs-3'></span>--> */}
        {/* <!--<span className='logo-sparrow'>S</span>--> */}
      </a>
      <div className="fancynavbar-toggler" onClick={() => toggleMenu(!isMenuOn)}>
        <svg
          className="fancynavbar-toggler-icon"
          viewBox="0 0 70 70"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            id="path-top"
            d="M20,25c0,0,22,0,30,0c16,0,18.89,40.71-.15,21.75C38.7,35.65,19.9,16.8,19.9,16.8"
          />
          <path id="path-middle" d="M20,32h30" />
          <path
            id="path-bottom"
            d="M19.9,46.98c0,0,18.8-18.85,29.95-29.95C68.89-1.92,66,38.78,50,38.78c-8,0-30,0-30,0"
          />
        </svg>
      </div>
      <div className="fancynavbar-addon">
        <a className="fancynavbar-addon-item" href="https://twitter.com/clabblurb">
          <FontAwesomeIcon icon={['fab', 'twitter']} />
        </a>
        <a className="fancynavbar-addon-item" href="https://www.facebook.com/clabblurb">
          <FontAwesomeIcon icon={['fab', 'facebook']} />
        </a>
        <a className="fancynavbar-addon-item" href="https://www.instagram.com/lauracinti/">
          <FontAwesomeIcon icon={['fab', 'instagram']} />
          </a>
        <a className="fancynavbar-addon-item" href="https://vimeo.com/user1654937">
          <FontAwesomeIcon icon={['fab', 'vimeo']} />
          </a>
        {/* <a className="fancynavbar-addon-item" href="#" data-remodal-target="language">
          <span className="text-sans-serif ls font-weight-black fs--1">EN</span>
        </a> */}
      </div>
    </div>
    <div className="fancynavbar-collapse">
      <ul className="fancynavbar-nav">
        {/* <AuthUserContext.Consumer>
          {authUser => (authUser ? <NavigationAuth /> : <NavigationNonAuth />)}
        </AuthUserContext.Consumer> */}
        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            exact
            to="/"
            activeClassName={HeaderLinkActive}
            onClick={() => toggleMenu(!isMenuOn)}
          >
            <span className="fancynav-link-content">Home</span>
          </HeaderNavLink>
        </li>
        {/* <li className="fancynav-item fancy-dropdown">
          <a className="fancynav-link fancy-dropdown-toggle" href="JavaScript:void(0)">
            <span className="fancynav-link-content">Projects</span>
          </a>
          <div className="fancy-dropdown-menu">
            <div className="row pb-4">
              <div className="col-auto pt-3">
                ....
                <a className="fancy-dropdown-item" href="#" onClick={() => toggleMenu(!isMenuOn)}>
                  Dropdown Link 1
                </a>
                <a className="fancy-dropdown-item" href="#" onClick={() => toggleMenu(!isMenuOn)}>
                  Dropdown Link 2
                </a>
                ....
              </div>
            </div>
          </div>
        </li> */}
        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/about"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">About</span>
          </HeaderNavLink>
        </li>

        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/projects"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Projects</span>
          </HeaderNavLink>
        </li>

        {/* <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/experiments"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Experiments</span>
          </HeaderNavLink>
        </li> */}

        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/events"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Events</span>
          </HeaderNavLink>
        </li>

        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/blogs"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Blogs</span>
          </HeaderNavLink>
        </li>

        {/* <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/resources"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Resources</span>
          </HeaderNavLink>
        </li> */}

        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/texts"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Writings</span>
          </HeaderNavLink>
        </li>

        <li className="fancynav-item">
          <HeaderNavLink
            className="fancynav-link"
            to="/contact"
            onClick={() => toggleMenu(!isMenuOn)}
            activeClassName={HeaderLinkActive}
          >
            <span className="fancynav-link-content">Get in Touch</span>
          </HeaderNavLink>
        </li>
      </ul>
    </div>
  </nav>
)

const NavigationAuth = () => (
  <li className="fancynav-item">
    <span className="fancynav-link-content">auth:yes</span>
  </li>
)
const NavigationNonAuth = () => (
  <li className="fancynav-item">
    <span className="fancynav-link-content">auth:no</span>
  </li>
)
// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = ({ layout }: ApplicationState) => ({
  isMenuOn: layout.isMenuOn
})

// Mapping our action dispatcher to props is especially useful when creating container components.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  toggleMenu: (isMenuOn: boolean) => dispatch(layoutActions.toggleMenu(isMenuOn))
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FancyHeader)

// export default FancyHeader
const HeaderNavLink = styled(NavLink)`
  /* margin: 0 1rem; */
`

const HeaderLinkActive = css`
  text-decoration: underline;
`
